/// <reference types="vite/client" />
import type { Config } from 'dompurify';
import DOMPurify from 'dompurify';

const purifier = import.meta.env.SSR
    ? DOMPurify(new (await import('jsdom')).JSDOM('').window)
    : DOMPurify;

export const sanitize = (dirty: string, config?: Config): string => purifier.sanitize(dirty, config);
